module.exports = __webpack_public_path__ + "img/kn.3bebbfa0.svg";